import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import TransmitInternalButton from './TransmitInternalButton';

export function InvoiceTransmitInternal() {
  const {
    isNfe,
    isNfc,
    isNfs,
    isInternalApiIssued,
    useInternalInvoiceApiNfe,
    useInternalInvoiceApiNfc,
    useInternalInvoiceApiNfs,
  } = useInvoiceFormContext();

  if (isNfe && (useInternalInvoiceApiNfe || isInternalApiIssued)) {
    return <TransmitInternalButton type={InvoiceType.NFE} />;
  }

  if (isNfc && (useInternalInvoiceApiNfc || isInternalApiIssued)) {
    return <TransmitInternalButton type={InvoiceType.NFC} />;
  }

  if (isNfs && (useInternalInvoiceApiNfs || isInternalApiIssued)) {
    return <TransmitInternalButton type={InvoiceType.NFS} />;
  }

  return null;
}
